export const getImageGalleryOnboardDismissed = state =>
  state.search.imageGalleryOnboardDismissed;
